jq(function ($) {
  if ($("[data-open-menu-hamburguer-sidebar]").length) {
    $(".background-overlay").on("click", function () {
      $("body").removeClass("menu_open sidebar-menu-open");
      document.querySelectorAll('[data-open-menu-hamburguer-sidebar]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    });
  }
});

/* Cabeçalho desktop: megamenu acionável por clique e teclado, além do hover. */
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 1025) return;

  const menuItems = Array.from(document.querySelectorAll('.section-header-navigation .menu-lv-1.has-megamenu'));
  const closeMenus = (except) => {
    menuItems.forEach((item) => {
      if (item === except) return;
      item.classList.remove('dm-menu-open');
      item.querySelector(':scope > .menu-lv-1__action')?.setAttribute('aria-expanded', 'false');
    });
  };

  menuItems.forEach((item) => {
    const trigger = item.querySelector(':scope > .menu-lv-1__action');
    const dropdown = item.querySelector(':scope > .menu-dropdown');
    if (!trigger || !dropdown) return;

    const dropdownId = dropdown.id || `dm-megamenu-${Math.random().toString(36).slice(2, 9)}`;
    dropdown.id = dropdownId;
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-controls', dropdownId);
    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = !item.classList.contains('dm-menu-open');
      closeMenus(item);
      item.classList.toggle('dm-menu-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.section-header-navigation .menu-lv-1.has-megamenu')) closeMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenus();
  });
});
